module.exports = __webpack_public_path__ + "static/media/6.cf1018d5.jpg";